module.exports = __webpack_public_path__ + "static/media/YB5M14_0.f98598ce.jpg";